import { ReactNode } from 'react';
import { useImageLoader } from 'hooks/useImageLoader';
import { CameraImage } from '../CameraImage';

type CameraPreviewProps = {
  url: string;
  loading?: boolean;
  children?: ReactNode;
  fullScreen?: boolean;
};

export const CameraPreview = (props: CameraPreviewProps): JSX.Element => {
  const { url, loading = false, children, fullScreen = false } = props;

  const imageLoadStatus = useImageLoader(url);

  return (
    <>
      <CameraImage
        url={url}
        loading={loading || imageLoadStatus === 'loading'}
        fullScreen={fullScreen}
      />
      {children}
    </>
  );
};
